// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__wrap {\n  width: 100%;\n  padding: 10px;\n  line-height: 1.6rem;\n  margin-top: 6px;\n  margin-bottom: 6px;\n  min-height: 60px;\n  align-items: center;\n  /* border-radius: 5px; */\n  /* border: 1px solid #eee; */\n  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 3px 0px,\n    rgba(0, 0, 0, 0.06) 0px 1px 2px 0px; */\n}\n", ""]);
// Exports
module.exports = exports;
